import { showToast } from "../../utils/toast";
import { replaceRow, sendJson } from "./request";
import { refreshList } from "./refresh";
import { enhanceFormControls } from "./form_controls";

const drawer = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-cs-drawer]");
const backdrop = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-cs-drawer-backdrop]");

function close(): void {
  const panel = drawer();
  if (!panel) return;
  panel.hidden = true;
  panel.innerHTML = "";
  const shade = backdrop();
  if (shade) shade.hidden = true;
  const url = new URL(window.location.href);
  if (url.searchParams.has("edit")) {
    url.searchParams.delete("edit");
    history.replaceState(history.state, "", url.toString());
  }
}

async function open(id: string): Promise<void> {
  const panel = drawer();
  if (!panel) return;
  try {
    const response = await fetch(`/customer_success/client_drawer?id=${encodeURIComponent(id)}`, { headers: { Accept: "text/html" } });
    if (!response.ok) throw new Error(String(response.status));
    panel.innerHTML = await response.text();
    enhanceFormControls(panel);
  } catch (_e) {
    showToast("Client not found", "error", 3000);
    return;
  }
  panel.hidden = false;
  (window as any).mountLogos?.();
  const shade = backdrop();
  if (shade) shade.hidden = false;
  panel.querySelector<HTMLInputElement>("input, select")?.focus();
}

async function submit(form: HTMLFormElement, churn = false): Promise<void> {
  const body = new FormData(form);
  if (churn) body.set("user_company[cs_datum_attributes][status]", "churned");
  const id = new URL(form.action, window.location.origin).searchParams.get("id") || "";
  const button = form.querySelector<HTMLButtonElement>("button[type=submit]");
  if (button) button.disabled = true;
  const { ok, data } = await sendJson(form.action, "PATCH", body, false);
  if (button) button.disabled = false;
  if (!ok) {
    showToast((data.errors || []).join(", ") || "Couldn't save the client", "error", 4000);
    return;
  }
  replaceRow(id, data.row_html);
  close();
  if (document.querySelector("[data-cs-client-page]:not([data-cs-panel])")) {
    const turbo = (window as any).Turbo;
    turbo ? turbo.visit(window.location.href, { action: "replace" }) : window.location.reload();
  } else {
    void refreshList();
  }
  showToast(churn ? "Marked as churned" : "Client saved");
}

export function bindCsClientDrawer(): void {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const edit = target.closest<HTMLElement>("[data-cs-edit-client]");
    if (edit) {
      e.preventDefault();
      void open(edit.dataset.csEditClient || "");
      return;
    }
    if (target.closest("[data-cs-drawer-close]") || target.matches("[data-cs-drawer-backdrop]")) return close();

    const form = target.closest<HTMLFormElement>("[data-cs-drawer-form]");
    if (!form) return;
    const confirm = form.querySelector<HTMLElement>("[data-cs-churn-confirm]");
    const mark = form.querySelector<HTMLElement>("[data-cs-mark-churned]");
    const asking = target.closest("[data-cs-mark-churned]") ? true : target.closest("[data-cs-churn-no]") ? false : null;
    if (asking !== null && confirm && mark) {
      confirm.hidden = !asking;
      mark.hidden = asking;
    }
    if (target.closest("[data-cs-churn-yes]")) void submit(form, true);
  });

  document.addEventListener("submit", (e) => {
    const form = e.target as HTMLFormElement;
    if (!form.matches("[data-cs-drawer-form]")) return;
    e.preventDefault();
    void submit(form);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer() && !drawer()!.hidden) close();
  });

  document.addEventListener("turbo:load", () => {
    const id = new URLSearchParams(window.location.search).get("edit");
    if (id && drawer()) void open(id);
  });
}
